import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toggleCartModal } from 'ducks/ui';
import { getCartItems, getTotalQuantity, getCartSubtotal } from 'ducks/cart';
import { Button } from 'components/shared';
import styled, { css } from 'styled-components';
import { theme } from 'styles';
import { Header, CartItem } from './components';

const StyledNavDrawer = styled.div`
  box-shadow: ${theme.boxShadow.big};
  font-size: 12px;
  position: fixed;
  right: 0;
  top: -9999px;
  z-index: ${theme.zIndices.NavDrawer};
  transition: all 0.3s, right 0s 0.3s;
  transform: translateY(100%);
  background-color: ${theme.colors.white};
  width: 31.75em;
  max-width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  ${props =>
    props.isOpen &&
    css`
      transition: all 0.3s, right 0s;
      top: 0;
      transform: translateY(0);
    `};
`;

const Wrapper = styled.div`
  padding: 0 24px;
`;

const Section = styled.div``;

const Subtotal = styled.div`
  padding: ${theme.sp.s} 0px;
  display: flex;
  justify-content: space-between;
`;
const SubtotalText = styled.div``;
const SubtotalPrice = styled.div``;
const Checkout = styled.div`
  margin: ${theme.sp.s} 0px;
  text-align: center;
`;
const KeepShopping = styled.div`
  cursor: pointer;
  text-align: center;
  margin: ${theme.sp.s} 0px;
`;

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  cartItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  quantity: PropTypes.number.isRequired,
  subtotal: PropTypes.number,
};

const defaultProps = {
  subtotal: 0,
};

const CartDrawer = function(props) {
  const { isOpen, closeDrawer, cartItems, quantity, subtotal } = props;
  return (
    <StyledNavDrawer isOpen={isOpen}>
      <Wrapper>
        <Header onClose={closeDrawer} quantity={quantity} />
        <Section>
          {!!cartItems &&
            cartItems.map(item => <CartItem key={item.id} item={item} />)}
        </Section>
        <Section>
          <Subtotal>
            <SubtotalText>Sub-total</SubtotalText>
            <SubtotalPrice>${subtotal}</SubtotalPrice>
          </Subtotal>
        </Section>
        <Section>
          <Checkout>
            <Button
              external
              href={`${
                process.env.GATSBY_MARKETTAP_PLATFORM_CLIENT_HOST
              }/checkout`}
            >
              Checkout
            </Button>
          </Checkout>
        </Section>
        <Section>
          <KeepShopping>
            <button onClick={closeDrawer}>Keep Shopping</button>
          </KeepShopping>
        </Section>
      </Wrapper>
    </StyledNavDrawer>
  );
};

CartDrawer.propTypes = propTypes;
CartDrawer.defaultProps = defaultProps;

const mapStateToProps = state => ({
  isOpen: state.ui.isCartModalOpen,
  cartItems: getCartItems(state),
  quantity: getTotalQuantity(state),
  subtotal: getCartSubtotal(state),
});
const mapDispatchToProps = { closeDrawer: toggleCartModal };
export default connect(mapStateToProps, mapDispatchToProps)(CartDrawer);



// WEBPACK FOOTER //
// ./src/components/shared/CartDrawer/CartDrawer.jsx